export const listeDossiersPath = '';
export const detailDossierPath = ':idDossier';
